
seedWebControllers.controller('IntegrationAppLogsCtrl', ['$scope', '$timeout', 'TranslationService', '$uibModalInstance', 'IntegrationAppConfigService',
    function ($scope, $timeout, TranslationService, $uibModalInstance, IntegrationAppConfigService) {
        $scope.translation = TranslationService.getActiveTranslation();

        $scope.automaticScroll = IntegrationAppConfigService.automaticScroll;

        $scope.updateAutomaticScroll = function () {
            IntegrationAppConfigService.updateAutomaticScroll($scope.automaticScroll);
        };
        
        $scope.cleanLogs = function () {
            $scope.logs = [];
            IntegrationAppConfigService.cleanLogs();
        };

        $scope.cancel = function () {
            $scope.closedModal = true;
            $uibModalInstance.close($scope.closedModal);
        };

        $scope.$on('onIntegrationAppLog', function (object, response) {
            if (response) {
                $scope.logs = IntegrationAppConfigService.logs;
                $scope.$apply();
                if ($scope.automaticScroll) {
                    $scope.followTail();
                }
            }
        });

        $scope.followTail = function () {
            $timeout(function () {
                var scroller = document.getElementById('log-screen');
                scroller.scrollTop = scroller.scrollHeight;
            }, 0, false);
        };

        $scope.logs = IntegrationAppConfigService.logs;
        $scope.followTail();
    }
]);
